import api from "@/lib/api";

let agency = "";
export const setHiringAgency = (a) => { agency = a || ""; };
const p = (params = {}) => ({ params: { ...params, ...(agency ? { agency } : {}) } });

export const hiring = {
  get: (url, params) => api.get(`/hiring${url}`, p(params)),
  post: (url, body, params) => api.post(`/hiring${url}`, body, p(params)),
  put: (url, body) => api.put(`/hiring${url}`, body, p()),
  patch: (url, body) => api.patch(`/hiring${url}`, body, p()),
  fileUrl: (id, download) => `${process.env.REACT_APP_BACKEND_URL}/api/hiring-files/${id}?${new URLSearchParams({ ...(download ? { download: 1 } : {}), ...(agency ? { agency } : {}) })}`,
};

export const STATUS_STYLE = {
  Registered: "bg-slate-100 text-slate-600", Applied: "bg-sky-50 text-sky-700", Review: "bg-indigo-50 text-indigo-700",
  Interview: "bg-amber-50 text-amber-700", Offer: "bg-violet-50 text-violet-700", Hired: "bg-emerald-50 text-emerald-700",
  Rejected: "bg-rose-50 text-rose-700", Withdrawn: "bg-slate-100 text-slate-500",
};
export const JOB_STATUS = { draft: ["Draft", "bg-slate-100 text-slate-600"], open: ["Published", "bg-emerald-50 text-emerald-700"],
  paused: ["Paused", "bg-amber-50 text-amber-700"], closed: ["Closed", "bg-slate-200 text-slate-600"], archived: ["Archived", "bg-slate-100 text-slate-400"] };
export const fmtDate = (v) => (v ? new Date(v.length === 10 ? `${v}T12:00:00` : v).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "—");
export const fmtDateTime = (v) => (v ? new Date(v).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" }) : "—");

// Opens a private hiring file through the authenticated API (cookies/bearer), never a public URL.
export async function openFile(id, download = false) {
  const r = await api.get(`/hiring-files/${id}`, { ...p(download ? { download: 1 } : {}), responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  if (download) {
    const a = document.createElement("a");
    a.href = url; a.download = (r.headers["content-disposition"] || "").match(/filename="([^"]+)"/)?.[1] || "file"; a.click();
  } else window.open(url, "_blank", "noopener");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
